import React from 'react'

import useTrainings from '../../hooks/useTrainings'
import Filter from './Filter'
import { FILTER_TRAINING_SLUG } from './filters.constants'

const FilterTraining: React.FC = () => {
  const { trainings } = useTrainings()

  if (!trainings) return null

  const options = trainings.map((training) => ({ label: training.name, value: training.id }))

  return <Filter slug={FILTER_TRAINING_SLUG} options={options} />
}

export default FilterTraining
